import { TableHeading } from "../../../../components/common/table/TableDesign";
const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const surveyTab1Heading: TableHeading[] = [
  { label: "Items" },
  { label: "ft3", align: "center" },
  { label: "Qty", align: "center" },
  { label: "Leave", align: "center" },
  { label: "Company", align: "center" },
  { label: "Cust", align: "center" },
  { label: "Store", align: "center" },
  { label: "Awk", align: "center" },
  { label: "Exp", align: "center" },
  { label: "HVI", align: "center" },
  { label: "HVI Value", align: "center" },
  // { label: "Clear", align: "center" },
  { label: "", align: "center" },
];

export const surveyTab1Fields = [
  {
    id: "item",
    placeHolder: "",
    type: "text",
    width: "300px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "ft3",
    placeHolder: "",
    type: "text",
    width: "100px",
    valueFormat: "price",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "quantity",
    placeHolder: "",
    type: "counter",
    width: "80px",
    valueFormat: "number",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "isLeave",
    name: "options",
    placeHolder: "",
    type: "radio",
    width: "50px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "isWeee",
    name: "options",
    placeHolder: "",
    type: "radio",
    width: "50px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "isCust",
    name: "options",
    placeHolder: "",
    type: "radio",
    width: "50px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
   {
    id: "isStore",
    name: "options",
    placeHolder: "",
    type: "checkbox",
    width: "50px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
    {
    id: "isAwk",
    name: "options",
    placeHolder: "",
    type: "checkbox",
    width: "50px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "isExp",
    name: "options",
    placeHolder: "",
    type: "checkbox",
    width: "50px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "isHVI",
    name: "options",
    placeHolder: "",
    type: "checkbox",
    width: "50px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "hviValue",
    placeHolder: "",
    type: "Value",
    width: "100px",
    valueFormat: "number",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  // {
  //   id: "isClear",
  //   name: "options",
  //   placeHolder: "",
  //   type: "checkbox",
  //   width: "100px",
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   patternAllowed: patternConstant?.ALPHANUMERIC,
  // },
];

export const surveyDefaultItem = {
  item: "",
  ft3: null,
  quantity: null,
  isLeave: false,
  isWeee: false,
  isCust: false,
  isClear: false,
  isStore:false,
  isAwk: false,
  isExp: false,
  isHVI: false,
  hviValue: "",
};

export const leadSurveyTab1Initial = [{ ...surveyDefaultItem }];

export const surveyTab3Heading: TableHeading[] = [
  { label: "Items" },
  { label: "ft3", align: "left" },
  { label: "Qty", align: "center" },
  // { label: "Dismantle Charge", align: "left", },
  // { label: "Sort Order", align: "left" },
  { label: "Move Equipment", align: "left" },
  { label: "Flag", align: "left" },
];

export const surveyTab3Fields = [
  {
    id: "item",
    placeHolder: "",
    type: "text",
    width: "300px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isDisabled:true,
  },
  {
    id: "ft3",
    placeHolder: "",
    type: "text",
    width: "100px",
    valueFormat: "price",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
    isDisabled:true,
  },
   {
    id: "quantity",
    placeHolder: "",
    type: "counter",
    width: "80px",
    valueFormat: "number",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isDisabled:true,
  },
  // {
  //   id: "dismentleCharges",
  //   placeHolder: "",
  //   type: "text",
  //   width: "100px",
  //   valueFormat: "price",
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   patternAllowed: patternConstant?.PRICE,
  // },
  // {
  //   id: "sortOrder",
  //   placeHolder: "",
  //   type: "text",
  //   width: "100px",
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   patternAllowed: patternConstant?.NUMERIC,
  // },
  {
    id: "linkedItem",
    placeHolder: "",
    type: "select",
    width: "300px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id:'flag',
    type:'list'
  }
];

export const surveySummaryFields = [
  // {
  //   id: "customerName",
  //   label: "Client Name",
  //   placeHolder: "Enter client name",
  //   type: "text",
  //   // isRequired: true,
  //   md: 2.5,
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   patternAllowed: patternConstant?.ALPHANUMERIC,
  //   editReadOnly: true,
  // },
  // {
  //   id:'title',
  //   label:'',
  //   md: 0.1,
  //   type:'title',
  // },
  {
    id: "removalDate",
    label: "Moving Date",
    placeHolder: "Select",
    type: "daterangebothvalue",
    // firstColmd: 1.5,
    md: 6,
    isRequired: true,
    disablePast: true,
  },
  {
    id: "summaryStatus",
    label: "Summary Status",
    placeHolder: "Select",
    type: "radio",
    row: true,
    isRequired: true,
    // firstColmd: 1.5,
    md: 6,
    radioOptions: [
      {
        label: "Confirmed",
        value: "confirmed",
      },
      {
        label: "Provisional",
        value: "provisional",
      },
      {
        label: "Unknown",
        value: "notTaking",
      },
    ],
  },

  {
    id: "customerEmail",
    label: "Email Address",
    placeHolder: "Enter email address",
    type: "text",
    // firstColmd: 3,
    md: 6,
    // isRequired: true,
    editReadOnly: false,
  },
  // {
  //   id:'title',
  //   label:'',
  //   md: 0.1,
  //   type:'title',
  // },
 
  {
    id: "customerPhone",
    label: "Tel Number",
    placeHolder: "Enter number",
    type: "contact",
    // firstColmd: 2,
    md: 6,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
    // editReadOnly: true,
  },
    {
    id: "contentValue",
    label: "Contents Value",
    placeHolder: "",
    type: "text",
    prefixIcon: "£",
    md: 6,
    patternAllowed: patternConstant?.NUMERIC,
  },
   {
    id: "customerAlternatePhone",
    label: "Alternate Tel Number",
    placeHolder: "Enter number",
    type: "contact",
    // firstColmd: 2,
    md: 6,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
    // editReadOnly: true,
  },
 
];
export const surveyCollectionSummaryFields = [
  
  {
    id: "street",
    label: "Address",
    placeHolder: "Enter moving from",
    type: "text",
    // firstColmd: 3,
    md: 6,
    isRequired: true,
    inputProps: {
      maxLength: 100,
    },
    isPaste:true,
    editReadOnly: false,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "purchaseStatus",
    label: "Purchase Status",
    placeHolder: "Select",
    type: "select",
    options: [
      "Unknown",
      "Renting",
      "No Chain",
      "Standard",
      "Has Keys",
      // "Rent",
      "Owned",
      "Lease",
      "Other",
    ],
//  firstColmd: 3,
    md: 6,
  },
 
  {
    id: "town",
    label: "Town",
    placeHolder: "Enter town",
    type: "text",
    // firstColmd: 3,
    md: 6,
    isRequired: true,
    inputProps: {
      maxLength: 100,
    },
    isPaste:true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
 {
    id: "country",
    label: "Country",
    placeHolder: "Select",
    type: "select",
    options: ["England", "Wales", "Scotland", "Northern Ireland", "India"],
    md: 3,
  },
  {
    id: "county",
    label: "County",
    placeHolder: "Select",
    type: "select",
    // inputProps: {
    //   maxLength: 100,
    // },
    // firstColmd: 3,
    md: 3,
  },
 
  {
    id: "postcode",
    label: "Postcode",
    placeHolder: "Enter postcode",
    type: "text",
  //  firstColmd: 3,
    md: 4,
    isRequired: true,
    inputProps: {
      maxLength: 8,
    },
    isPaste:true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  
  {
    id: "isPostcodeVerified",
    label: "",
    placeHolder: "",
    type: "checkbox",
    // width: "100px",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  
 
  {
    id: "paces",
    label: "Paces",
    placeHolder: "--",
    type: "text",
    // firstColmd: 3,
    md: 3,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.NUMERIC,
    isPaste:false,
  },
  {
    id: "flightOfStairs",
    label: "Flight of Stairs",
    placeHolder: "--",
    type: "text",
  //  firstColmd: 3,
    md: 3,
    inputProps: {
      maxLength: 3,
    },
    isPaste:false,
    patternAllowed: patternConstant?.NUMERIC,
  },
 
  {
    id: "type",
    label: "Property Type",
    placeHolder: "Select",
    type: "select",
    options: [
      // "Unknown",
      // "House",
      // "Town House",
      // "Mainsonette",
      // "Flat",
      // "Bungalow",
      // "Cottage",
      // "Self Store",
      // "Commercial",
    ],
    // firstColmd: 3,
    md: 3,
  },
  
  {
    id: "houseSize",
    label: "Bedrooms",
    placeHolder: "--",
    type: "text",
    // firstColmd: 3,
    md: 3,
    inputProps: {
      maxLength: 3,
    },
    isPaste:false,
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "floors",
    label: "Floors",
    placeHolder: "--",
    type: "text",
   firstColmd: 3,
    md: 3,
    inputProps: {
      maxLength: 3,
    },
    isPaste:false,
    patternAllowed: patternConstant?.NUMERIC,
  },
 
  {
    id: "liftAvailability",
    label: "Lift",
    placeHolder: "Select",
    type: "select",
    options: ["Yes", "No"],
    // firstColmd: 3,
    md: 3,
  },
   {
    id: "volume",
    label: "Volume",
    placeHolder: "Enter volume",
    type: "text",
    md: 3,
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "volumeUnit",
    label: "Unit",
    placeHolder: "Select",
    type: "select",
    options: ["m3", "ft3"],
    md: 3,
    // width: "140px",
  },
    {
    id: "access",
    label: "Access",
    placeHolder: "Select",
    type: "select",
    options: [
      "Driveway",
      "Onroad",
      "Car Park",
      "Allocated",
      "Unknown",
    ],
//  firstColmd: 3,
    md: 3,
  },
  
];

export const surveyDeliverySummaryFields = [
  
  {
    id: "street",
    label: "Address",
    placeHolder: "Enter moving from",
    type: "text",
    // firstColmd: 3,
    md: 6,
    // isRequired: true,
    inputProps: {
      maxLength: 100,
    },
    editReadOnly: false,
    isPaste:true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "purchaseStatus",
    label: "Purchase Status",
    placeHolder: "Select",
    type: "select",
    options: [
      "Unknown",
      "Renting",
      "No Chain",
      "Standard",
      "Has Keys",
      // "Rent",
      "Owned",
      "Lease",
      "Other",
    ],
 firstColmd: 3,
    md: 6,
  },
 
  {
    id: "town",
    label: "Town",
    placeHolder: "Enter town",
    type: "text",
    firstColmd: 3,
    md: 6,
    // isRequired: true,
    inputProps: {
      maxLength: 100,
    },
    isPaste:true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "country",
    label: "Country",
    placeHolder: "Select",
    type: "select",
    options: ["England", "Wales", "Scotland", "Northern Ireland", "India"],
    md: 3,
  },
  {
    id: "county",
    label: "County",
    placeHolder: "Select",
    type: "select",
    // inputProps: {
    //   maxLength: 100,
    // },
    firstColmd: 3,
    md: 3,
  },
 
  {
    id: "postcode",
    label: "Postcode",
    placeHolder: "Enter postcode",
    type: "text",
   firstColmd: 3,
    md: 4,
    // isRequired: true,
    inputProps: {
      maxLength: 8,
    },
    isPaste:true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  
  {
    id: "isPostcodeVerified",
    label: "",
    placeHolder: "",
    type: "checkbox",
    // width: "100px",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  
 
  {
    id: "paces",
    label: "Paces",
    placeHolder: "--",
    type: "text",
    firstColmd: 3,
    md: 3,
    inputProps: {
      maxLength: 3,
    },
    isPaste:false,
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "flightOfStairs",
    label: "Flight of Stairs",
    placeHolder: "--",
    type: "text",
   firstColmd: 3,
    md: 3,
    inputProps: {
      maxLength: 3,
    },
     isPaste:false,
    patternAllowed: patternConstant?.NUMERIC,
  },
 
  {
    id: "type",
    label: "Property Type",
    placeHolder: "Select",
    type: "select",
    options: [
      "Unknown",
      "House",
      "Town House",
      "Mainsonette",
      "Flat",
      "Bungalow",
      "Cottage",
      "Self Store",
      "Commercial",
    ],
    firstColmd: 3,
    md: 3,
  },
  
  {
    id: "houseSize",
    label: "Bedrooms",
    placeHolder: "--",
    type: "text",
    firstColmd: 3,
    md: 3,
    inputProps: {
      maxLength: 3,
    },
     isPaste:false,
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "floors",
    label: "Floors",
    placeHolder: "--",
    type: "text",
   firstColmd: 3,
    md: 3,
    inputProps: {
      maxLength: 3,
    },
     isPaste:false,
    patternAllowed: patternConstant?.NUMERIC,
  },
 
  {
    id: "liftAvailability",
    label: "Lift",
    placeHolder: "Select",
    type: "select",
    options: ["Yes", "No"],
    firstColmd: 3,
    md: 3,
  },
 
  
];

// Static base radio options reused by dynamic and static fields
const SERVICE_RADIO_OPTIONS = [
  { label: "Quote", value: true },
  { label: "Decline", value: false },
];

// Only the always-present static fields (notes + hardcoded requirements).
// Dynamic service fields are generated at runtime via buildSurveyServiceFields().
export const surveyServiceSummaryFields = [
  {
    id: "notes",
    label: "Notes",
    placeHolder: "",
    type: "textarea",
    md: 10.5,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    editReadOnly: false,
    inputProps: {
      maxLength: 500,
    },
  },
  {
    id: "insurance",
    label: "Insurance",
    placeHolder: "Select",
    type: "radio",
    row: true,
    md: 2.5,
    radioOptions: SERVICE_RADIO_OPTIONS,
    isRequirement: true,
  },
  {
    id: "material",
    label: "Material",
    placeHolder: "Select",
    type: "radio",
    row: true,
    md: 2.5,
    radioOptions: SERVICE_RADIO_OPTIONS,
    isRequirement: true,
  },
];

/**
 * Builds the full service+requirement field list for the survey summary panel.
 *
 * @param defaultServiceList  – array from Redux `state.review.defaultServiceList`
 * @param isProfessional      – whether the professional plan is active
 * @param isCustomer          – whether the current user is a CUSTOMER
 */
export const buildSurveyServiceFields = (
  defaultServiceList: any[],
  isProfessional: boolean,
  isCustomer: boolean,
): any[] => {
  const radioOptions = SERVICE_RADIO_OPTIONS;

  // Map API services → radio fields; use service.type as the field id.
  const dynamicServiceFields = (defaultServiceList || []).map((svc: any) => ({
    id: svc.type,           // e.g. "removal", "intostore", "fullpack" …
    label: svc.name,        // e.g. "Removal, Door to Door"
    placeHolder: "Select",
    type: "radio" as const,
    row: true,
    md: 2.5,
    radioOptions,
    isService: true,
  }));

  // Notes is always first
  const notesField = surveyServiceSummaryFields[0];

  // Hardcoded requirement fields (insurance + material) are always shown
  const requirementFields = surveyServiceSummaryFields.slice(1); // insurance, material

  const allFields = [
    ...(isCustomer ? [] : [notesField]),
    ...dynamicServiceFields,
    ...requirementFields,
  ];

  return allFields;
};

export const SELECTED_SURVEY_ITEM_FIELDS = [
  
  {
    id: "we_dismantle",
    label: "Company Dismantle",
    placeHolder: "",
    type: "textarea",
    md: 12,
    editReadOnly: true,
    inputProps: {
      maxLength: 5000,
    },
  },
  {
    id: "leave_items",
    label: "Leave - do NOT take these items",
    placeHolder: "",
    type: "textarea",
    md: 12,
    editReadOnly: true,
  },
  {
    id: "awkward_items",
    label: `Awkward Items`,
    placeHolder: "",
    type: "textarea",
    md: 12,
    editReadOnly: true,
  },
   {
    id: "export_wrap_items",
    label: `Export Wrap`,
    placeHolder: "",
    type: "textarea",
    md: 12,
    editReadOnly: true,
  },
  {
    id: "customer_items",
    label: `Customer Item`,
    placeHolder: "",
    type: "textarea",
    md: 12,
    editReadOnly: true,
  },
  {
    id: "store_items",
    label: `Store Item`,
    placeHolder: "",
    type: "textarea",
    md: 12,
    editReadOnly: true,
  }
  
];

export const FT3_TO_M3 = 0.0283168; // 1 ft³ = 0.0283168 m³
export const M3_TO_FT3 = 35.3147;

export const calculateRoomVolume = (items: any[] = []) => {
  const total = items?.reduce((total: number, item: any) => {
     // Skip leave items
    if (item?.isLeave) {
      return total;
    }
    const ft3 = Number(item?.ft3) || 0;
    const qty = Number(item?.quantity) || 0;

    return total + (ft3 * qty * FT3_TO_M3);
  }, 0);

  return parseFloat(total.toFixed(2)); // return 2 decimal places
};
